import { render, staticRenderFns } from "./PartnerMarkets.vue?vue&type=template&id=27f89645&lang=pug&"
import script from "./PartnerMarkets.vue?vue&type=script&lang=js&"
export * from "./PartnerMarkets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports